import n from "dayjs";
function f(r, t = "YYYY-MM-DD", i = []) {
  return !Array.isArray(r) || r.length !== 2 || !r.every((e) => e instanceof n) ? i : r.map((e) => e.format(t));
}
function c(r) {
  return Array.isArray(r) ? r.length !== 2 ? [void 0, void 0] : r.every((t) => t instanceof n) ? r : r.every((t) => typeof t == "number") ? r.map((t) => {
    if (t.toString().length === 13)
      return n(t);
    if (t.toString().length === 10)
      return n(t * 1e3);
  }) : [void 0, void 0] : [void 0, void 0];
}
function g(r, t = "YYYY-MM-DD", i = "") {
  return r instanceof n ? r.format(t) : i;
}
function y(r) {
  try {
    return r instanceof n ? r : typeof r == "number" ? r.toString().length === 13 ? n(r) : r.toString().length === 10 ? n(r * 1e3) : void 0 : n(r);
  } catch {
    return;
  }
}
export {
  g as formatDatePickerValue,
  f as formatRangePickerValue,
  y as parseDatePickerValue,
  c as parseRangePickerValue
};
